import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ValidationService } from '../../../app/validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs-compat/Subscription';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-create-device',
  templateUrl: './admin-create-device.component.html',
  styleUrls: ['./admin-create-device.component.scss'],
  standalone: true,
  imports:[FormsModule,MatToolbar,MatFormFieldModule,ReactiveFormsModule]
})
export class AdminCreateDeviceComponent implements OnInit {
  private addDeviceMacUrl: any = BaseUrlConstantsService.ADD_DEVICE;
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  private updateInventoryUrl = BaseUrlConstantsService.UPDATE_INVENTORY;
  private getInventoryByIDUrl = BaseUrlConstantsService.GET_INVENTORY_BY_ID;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public checkLicenceAvailability = BaseUrlConstantsService.CHECK_AVAILABILITY;
  public LicenceStatus: boolean;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public uForm: any;
  public deviceTypeID: any;
  public deviceTypeName: any;
  public pageType: any;
  public clientList: any;
  public editCase: boolean;
  public showLogin = true;
  public showUpdate = false;
  public pageTitle: string;
  public deviceMac: any;
  public deviceID: any;
  public url: any;
  public userId: any;
  public assetID: any;
  public id: any;
  public showCancelBtn: boolean;
  public updateDataReq: any = false;
  public _imageId = null;
  public selectedClientId = null;
  public _imgUrl = "./assets/img/no.png";
  public breadcrumbsArray: any = [{
    page_ref: 'view-device-type',
    page_title: 'device type'
  }, {
    page_ref: 'devices',
    page_title: 'devices'
  }, {
    page_ref: 'add-device',
    page_title: 'add inventory'
  }];
  public fileName = '';
  public percentDone = 0;
  public uploadSuccess: boolean;
  public selectedClientIdForAsso: any = null;
  public makeUpdatedisable: boolean;
  public msgLimit:string;

  constructor(
    public router: Router,
    private http: HttpClient,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder) {
    this.selectedClientId = localStorage.getItem("user_id");
    activeRoute.queryParams.subscribe(params => {
      this.assetID = params['assetid']
      this.deviceTypeID = params[`deviceTypeId`];
      this.deviceID = params[`id`];
      this.selectedClientId = params[`device_user_id`];
      this.selectedClientIdForAsso = params[`device_user_id`];
      this.checkStatus(this.selectedClientIdForAsso);
      if (this.deviceID != undefined) {
        this.breadcrumbsArray[2].page_title = "edit inventory";
      }
      this.deviceTypeName = params[`deviceTypeName`];
      if (params[`type`] !== undefined) {
        this.pageType = params[`type`];
        this.deviceMac = params[`deviceMac`];
        if (this.pageType === 'editInventory') {
          this.editCase = true;
          this.showUpdate = true;
          this.pageTitle = 'Edit Inventory';
          this.showLogin = false;
          this.getInventoryByID();
        } else {
          this.editCase = false;
          this.showUpdate = false;
          this.pageTitle = 'Add Inventory';
          this.breadcrumbsArray[2].page_title = "add inventory";
          this.showLogin = true;
        }
      }
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }


  selectedClient(value) {
    this.makeUpdatedisable = true;
    this.selectedClientIdForAsso = value;
    this.checkStatus(value);
  }

  checkStatus(value) {
    this.changeService.loader(true);
    this.service.getData(this.checkLicenceAvailability + "/" + value).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.code == 200) {
        if (JSON.parse(JSON.stringify(res)).data.message === 'limit exceeded') {
          this.msgLimit = "This client licence limit exceeded";
          this.makeUpdatedisable = true;
          this.LicenceStatus = true;
        } else {
          this.msgLimit = "";
          this.makeUpdatedisable = false;
          this.LicenceStatus = false;
        }
      }
    });
  }


  upload(files: any) {
    if (files[0].name !== undefined && files[0].name === '') {
      this.fileName = '';
    } else {
      this.showCancelBtn = true;
      this.fileName = files[0].name;
    }
    const body = {
      name: files[0].name,
      file_type: files[0].type,
      file_ext: files[0].type.split('/').pop()
    };

    this.service.postData(this.imageUploadUrl, body).then(res => {
      const signed_request = JSON.parse(JSON.stringify(res)).data.body.signed_request;
      this.url = JSON.parse(JSON.stringify(res)).data.body.relative_url;
      this.userId = localStorage.getItem('user_id');
      this.id = JSON.parse(JSON.stringify(res)).data.body.id;
      this.uploadAndProgress(files, signed_request, this.url, this.userId, this.id);
    });
  }

  private subscription: Subscription = new Subscription();
  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(this.http.put(signedRequest, files[0], { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showCancelBtn = false;
          this.fileName = '';
          this.uploadSuccess = true;
          this._imgUrl = imageurl;
        }
      }));
  }

  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = '';
    this.showCancelBtn = false;
  }

  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: this.deviceTypeID,
        deviceName: this.deviceTypeName
      }
    };
    this.router.navigate([name], navigationExtras);
  }

  ngOnInit() {
    this.uForm = this.formBuilder.group({
      device_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      client_value: new FormControl(''),
      mac_address: new FormControl('', [Validators.required, this.noWhitespaceValidator])
    });
    this.getAllClients();
  }

  getInventoryByID() {
    this.changeService.loader(true);
    console.log(this.getInventoryByIDUrl + "/" + this.deviceID,'admininven')
    this.service.getData(this.getInventoryByIDUrl + "/"+"v2"+"/" + this.deviceMac + "/"+ this.assetID + "/" + this.userId).then(res => {
      this.changeService.loader(false);
      let resp = JSON.parse(JSON.stringify(res))[0];
      this.uForm = this.formBuilder.group({
        device_name: new FormControl(this.deviceTypeName, [Validators.required, this.noWhitespaceValidator]),
        client_value: new FormControl(parseInt(this.selectedClientId), Validators.required),
        mac_address: new FormControl(resp.mac_address, [Validators.required, this.noWhitespaceValidator])
      });
    });
  }

  update() {
    if (isNaN(this.uForm.value.client_value)) {
      this.service.showError("You haven't choose any client.");
    } else {
      const body = {
        user_id: this.selectedClientIdForAsso,
        device_id: this.deviceTypeID,
        name: this.uForm.value.device_name,
        mac_address: this.uForm.value.mac_address,
        status: 'associated'
      };
      this.changeService.loader(true);
      this.service.putData(this.updateInventoryUrl + "/" + this.deviceID, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Device association successful.');
          const navigationExtras = {
            skipLocationChange: true,
            queryParams: {
              deviceTypeId: this.deviceTypeID
            }
          };
          this.router.navigate(['/devices'], navigationExtras);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }

  getAllClients() {
    this.changeService.loader(true);
    this.service.getData(this.clientListingUrl + "CLIENT").then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  addDevice(typeId, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceTypeName: name
      }
    };
    this.router.navigate(['/add-device'], navigationExtras);
  }

  saveDevice() {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        user_id: this.selectedClientId,
        device_id: this.deviceTypeID,
        mac_address: this.uForm.value.mac_address,
        name: this.uForm.value.device_name,
      };
      this.changeService.loader(true);
      this.service.addUserPost(this.addDeviceMacUrl, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('User mac address registered successfully');
          const navigationExtras = {
            skipLocationChange: true,
            queryParams: {
              deviceTypeId: this.deviceTypeID
            }
          };
          this.router.navigate(['/devices'], navigationExtras);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }
}
